import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { RestaurantDetailsService } from './restaurant-details.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private message = new Subject<any>();
  private orderReceivedAck = new Subject<any>();
  private posOrder = new Subject<any>();
  private posPayment = new Subject<any>();
  private ordersMM = new Subject<any>();
  private merge = new Subject<any>();
  private restDetails = new Subject<any>();

  edit$ = this.message.asObservable();
  order$ = this.posOrder.asObservable();
  posPm$ = this.posPayment.asObservable();
  ordersmm$ = this.ordersMM.asObservable();
  merge$ = this.merge.asObservable();
  restDetails$ = this.restDetails.asObservable();
  orderReceivedAck$ = this.orderReceivedAck.asObservable();

  private tableDetails$: BehaviorSubject<any> = new BehaviorSubject(null);
  private menuMappingDetails$: BehaviorSubject<any> = new BehaviorSubject(null);
  private selectedOutletId$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private _restaurantDetailsService: RestaurantDetailsService) {}

  get restaurantDetails$(): BehaviorSubject<any> {
    return this._restaurantDetailsService.detailsSubject;
  }

  sendMessage(message: any) {
    this.message.next(message);
  }

  sendOrderRefreshAck(message: any) {
    this.orderReceivedAck.next(message);
  }

  sendOrderDetails(message: any) {
    this.posOrder.next(message);
  }

  posPaymentMesaage(message: any) {
    this.posPayment.next(message);
  }

  orderActionMessage(message: any) {
    this.ordersMM.next(message);
  }
  sendMergeIds(message: any) {
    this.merge.next(message);
  }
  sendRestDetails(message: any) {
    this.restDetails.next(message);
  }
  getRestaurantDataObs() {
    return this._restaurantDetailsService.restaurantDetails$;
  }
  setRestaurantDataObs(data) {
    this._restaurantDetailsService.setDetails(data);
  }
  getAllTableDataObs() {
    return this.tableDetails$.asObservable();
  }
  setAllTableDataObs(data) {
    this.tableDetails$.next(data);
  }
  getMenuMappingObs() {
    return this.menuMappingDetails$.asObservable();
  }
  setMenuMappingObs(data) {
    this.menuMappingDetails$.next(data);
  }
  getOutletListObs() {
    return this.selectedOutletId$.asObservable();
  }
  setOutletListObs(data) {
    this.selectedOutletId$.next(data);
  }
}
